import React from "react";
import { postRequest } from "./QuoteApiService";

export const setQuoteNew = (rec) => {

    console.log("userServices > setQuoteNew called...");
    
    return new Promise((resolve, reject) => {
      try {
        // do an SDK, DB call or API endpoint axios call here and return the promise.
        postRequest('SetQuoteNew/', rec)
        .then((res) => {
          console.log("SetQuoteNew > axios res=", res);
          resolve(res.data);
        })
        .catch((err) => {
          console.log("SetQuoteNew > axios err=", err);
          reject("Error in SetQuoteNew axios!");
        });
      } catch (error) {
        console.error("in services > SetQuoteNew, Err===", error);
        //reject(SYSTEM_ERROR);
      }
    });
  
}